import { gql, useQuery } from "@apollo/client";
import { merge } from "lodash";

import { useFeatureFlags } from "src/shared/components/FeatureFlags";

export const GET_USER_PROFILE = gql`
  query GetUserProfile {
    user_profile {
      is_financing_status_stale
      is_has_buyer_agent_stale
    }
  }
`;

const useUserProfileQuery = () => {
  const { data, error, loading } = useQuery(GET_USER_PROFILE);

  const { flags } = useFeatureFlags(
    ["fossa_new_beth_signals_show_financing_question"],
    true
  );

  const getShowPostSubmitQuestionnaire = () => {
    if (!data?.user_profile || !flags) {
      return false;
    }

    const is_financing_status_stale =
      data.user_profile.is_financing_status_stale &&
      flags.fossa_new_beth_signals_show_financing_question;

    const questionsWithConditions = merge({}, data.user_profile, {
      is_financing_status_stale
    });

    return Object.values(questionsWithConditions || {}).includes(true);
  };

  const showPostSubmitQuestionnaire = getShowPostSubmitQuestionnaire();

  return {
    data,
    error,
    // TODO FOS-1638: in hook's result loading is always false
    loading,
    showPostSubmitQuestionnaire
  };
};

export default useUserProfileQuery;
